
import { Vue, Component, Prop } from "vue-property-decorator";
import StatusChip from "@/components/icons/StatusChip.vue";
import ChipStatus from "@/entities/ChipStatus";
@Component({
  components: { StatusChip },
})
export default class CardInfoChip extends Vue {
  @Prop({ type: String, default: "" }) readonly message!: string;
  @Prop({ type: String, default: "" }) readonly textclass!: string;
  @Prop({ type: Boolean, default: true }) readonly showDecoration!: boolean;
  @Prop({ type: Boolean, default: false }) readonly green!: boolean;
  @Prop({ type: Boolean, default: false }) readonly gray!: boolean;
  @Prop({ type: Boolean, default: false }) readonly red!: boolean;

  get defaultGreen(): boolean {
    return !this.gray;
  }

  get chipStatus(): ChipStatus {
    if (this.gray) {
      return ChipStatus.INFO;
    }
    if (this.red) {
      return ChipStatus.ALERT;
    }
    return ChipStatus.ATTENTION;
  }
}
